import type React from "react";

import { useRoutes } from "react-router-dom";

import { Treatment } from "routes/patients/views/Treatment";
import { Container } from "shared/atoms/Container";
import { usePageContentOffsetTop } from "shared/styles/usePageContentOffsetTop";

import {
  Confirmation,
  Create,
  Exercise,
  ExerciseForm,
  ExerciseFormParent,
  Exercises,
  Lesson,
  LessonForm,
  LessonFormParent,
  Lessons,
  Library,
  Template,
  TemplateForm,
  Templates,
} from "./views";

export const LibraryRoutes: React.FC = () => {
  const offsetTop = usePageContentOffsetTop();
  const routes = useRoutes([
    {
      path: "/",
      element: <Library />,
      children: [
        {
          path: "your-library",
          children: [
            { path: "confirmation", element: <Confirmation /> },
            { path: "exercises", element: <Exercises /> },
            { path: "exercises/:id", element: <Exercise /> },
            { path: "exercises/:id/edit", element: <ExerciseFormParent /> },
            { path: "exercises/new", element: <ExerciseForm /> },
            { path: "lessons", element: <Lessons /> },
            { path: "lessons/:id", element: <Lesson /> },
            { path: "lessons/:id/edit", element: <LessonFormParent /> },
            { path: "lessons/new", element: <LessonForm /> },
            { path: "new", element: <Create /> },
            { path: "templates", element: <Templates /> },
            { path: "templates/:id", element: <Template /> },
            // TODO: Replace <TemplateForm /> with <Treatment editorSettings={{ context: "library", mode: "edit" }} />
            // when we have migrated all templates to treatment schedules
            { path: "templates/:id/edit", element: <TemplateForm /> },
            {
              path: "templates/:templateID/edit_template",
              element: <Treatment editorSettings={{ context: "library", mode: "edit" }} />,
            },
            {
              path: "templates/new_template",
              element: <Treatment editorSettings={{ context: "library", mode: "build" }} />,
            },
          ],
        },
      ],
    },
  ]);

  return <Container $pageContentOffsetTop={offsetTop}>{routes}</Container>;
};
